import { z } from 'zod';

import { Platform } from '../enums.js';

import { Ulid } from './common.js';

export const NotificationType = z.enum([
  'lead.assigned',
  'lead.moved',
  'lead.created',
  'comment.created',
  'comment.mention',
  'reminder.due',
  'flowchart.published',
  'security.suspicious_login',
  'security.password_reset',
]);
export type NotificationType = z.infer<typeof NotificationType>;

export const Notification = z.object({
  id: Ulid,
  userId: Ulid,
  type: NotificationType,
  title: z.string().min(1).max(160),
  body: z.string().nullable(),
  payload: z.record(z.unknown()),
  readAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
});
export type Notification = z.infer<typeof Notification>;

export const PushDevice = z.object({
  id: Ulid,
  userId: Ulid,
  platform: Platform,
  fcmToken: z.string().min(1),
  appVersion: z.string().nullable(),
  lastSeenAt: z.string().datetime(),
});
export type PushDevice = z.infer<typeof PushDevice>;

export const PushDeviceRegister = z.object({
  platform: Platform,
  fcmToken: z.string().min(10).max(4096),
  appVersion: z.string().max(40).optional(),
});
export type PushDeviceRegister = z.infer<typeof PushDeviceRegister>;

export const NotificationEventType = z.enum([
  'lead.created',
  'lead.updated',
  'lead.moved',
  'lead.assigned',
  'lead.commented',
  'lead.documented',
  'reminder.due',
  'project.notes_updated',
]);
export type NotificationEventType = z.infer<typeof NotificationEventType>;

export const NotificationSubscription = z.object({
  scope: z.enum(['global', 'project']),
  scopeId: Ulid.nullable(),
  eventType: NotificationEventType,
  enabled: z.boolean(),
});
export type NotificationSubscription = z.infer<typeof NotificationSubscription>;

export const NotificationSubscriptionsUpdate = z.object({
  items: z.array(NotificationSubscription).max(200),
});
export type NotificationSubscriptionsUpdate = z.infer<typeof NotificationSubscriptionsUpdate>;
